import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  DatePicker,
  Table,
  notification,
  Spin,
  List,
  Typography,
  Modal,
  Tag,
  Space,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { Container } from '../../components/Bloco/styles';
import CaixaDeFiltros from '../../components/CaixaDeFiltros';
import DescriberPayload from '../../components/DescriberPayload';
import { colunas } from './colunas';
import { ModalCentralizada } from '../../components/ModalCentralizado/style';
import api from '../../services/api';
import { convertToIsoString } from '../../helpers/utils';

const ENDPOINT_MAXYS_API = 'integracoesMaxys';
const { RangePicker } = DatePicker;
export function ErrosWebhook() {
  const [formFilter] = Form.useForm();
  const [webhooks, setWebhooks] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [bloquearBotaoReprocessar, setBloquearBotaoReprocessar] = useState(
    false
  );
  const [loadingApiData, setLoadingApiData] = useState(false);
  const [
    abrirModalDeReprocessamento,
    setAbrirModalDeReprocessamento,
  ] = useState(false);
  const [loadingReprocessamento, setLoadingReprocessamento] = useState(false);
  const [reprocessarData, setReprocessarData] = useState([]);
  const [pager, setPager] = useState({ current: 0, pageSize: 10 });

  const rowSelection = {
    getCheckboxProps: record => ({
      disabled: record.status_reprocessando,
    }),
    selectedRowKeys,
    onChange: (selectedRowsKeys, selectedRows) => {
      setSelectedRowKeys([...selectedRowsKeys]);
      setReprocessarData([...selectedRows]);
    },
  };

  function montarFiltros() {
    let identificador = formFilter.getFieldValue('identificador');
    const periodo = formFilter.getFieldValue('periodo');
    const dataInicio = periodo && periodo[0]?.format('yyyy-MM-DD');
    const dataFim = periodo && periodo[1]?.format('yyyy-MM-DD');
    const tipo = formFilter.getFieldValue('origem');
    const erroMensagem = formFilter.getFieldValue('erroMensagem');

    if (isNaN(identificador)) {
      identificador = null;
    }

    return {
      identificador,
      tipo,
      dataInicio: convertToIsoString(dataInicio),
      dataFim: convertToIsoString(dataFim),
      erroMensagem,
    };
  }

  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      setBloquearBotaoReprocessar(true);
    } else {
      setBloquearBotaoReprocessar(false);
    }
  }, [selectedRowKeys]);

  const exibirModal = modaloValue => {
    setShowModal(true);
    setModalData(modaloValue);
  };

  const exibirModalReprocessamento = () => {
    setAbrirModalDeReprocessamento(true);
  };

  const buscaFiltrada = async (pagination = { current: 1, pageSize: 10 }) => {
    setLoadingApiData(true);
    try {
      if (isNaN(pagination?.pageSize)) {
        pagination.pageSize = 10;
      }

      if (isNaN(pagination?.current)) {
        pagination.current = 1;
      }

      const filtros = montarFiltros();

      const hooksComBotao = [];
      const response = await api.get(ENDPOINT_MAXYS_API, {
        params: {
          ...filtros,
          limit: pagination?.pageSize,
          offset: (pagination?.current - 1) * pagination?.pageSize,
          order: 'DESC',
        },
      });
      const webhookTemp = response?.data?.data;
      webhookTemp.forEach(whook => {
        whook.key = whook.id;
        whook.status_reprocessando = whook.reprocessando;
        whook.reprocessando = (
          <Tag color={whook.reprocessando ? 'green' : 'red'}>
            {whook.reprocessando ? 'Reprocessando' : 'Falha'}
          </Tag>
        );
        whook.acoes = (
          <Space>
            <Button
              icon={<EyeOutlined />}
              color="#52c41a"
              onClick={() => exibirModal(whook)}
            />
          </Space>
        );

        hooksComBotao.push(whook);
      });

      setPager({ ...pagination, total: response?.data?.total });
      setWebhooks(hooksComBotao);
    } catch (e) {
      notification.error({
        description: 'Erro ao carregar erros de integração',
      });
    } finally {
      setLoadingApiData(false);
    }
  };

  const reprocessarWebhooks = async () => {
    try {
      setLoadingReprocessamento(true);
      await api.post(`${ENDPOINT_MAXYS_API}/reprocessar`, {
        integracoes: selectedRowKeys,
      });

      setSelectedRowKeys([]);
      setReprocessarData([]);
      setAbrirModalDeReprocessamento(false);

      notification.success({
        description: 'Sucesso ao reprocessar webhooks!',
      });
    } catch (err) {
      notification.error({
        description: 'Erro ao reprocessar webhooks',
      });
    } finally {
      setLoadingReprocessamento(false);
      buscaFiltrada();
    }
  };

  function FormularioFiltros() {
  return <Form layout="vertical" form={formFilter} size="large">
      <Row gutter={[32, 0]}>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item name="periodo" label="Período">
            <RangePicker format="DD/MM/YYYY" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item initialValue="" name="origem" label="Origem">
            <Select>
              <Select.Option value=""> Selecione </Select.Option>
              <Select.Option value="webhookPagamentoPedagio">
                Pagamento de Pedágio
              </Select.Option>
              <Select.Option value="webhookPagamentoProtocolo">
                Pagamento de Protocolo
              </Select.Option>
              <Select.Option value="webhookPagamentoParcela">
                Pagamento de Parcela
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item initialValue="" name="identificador" label="Identificador">
            <Input name="identificador" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item
            initialValue=""
            name="erroMensagem"
            label="Mensagem de Erro"
          >
            <Input name="erroMensagem" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[0, 0]} justify="end">
        <Col>
          <Form.Item>
            <Button type="secondary" onClick={buscaFiltrada}>
              Filtrar
            </Button>
          </Form.Item>
        </Col>
      </Row>
         </Form>;
}

  return (
    <>
      <Container>
        <CaixaDeFiltros>
          <FormularioFiltros />
        </CaixaDeFiltros>
      </Container>
      <Container>
        <ModalCentralizada
          title="Request e Response"
          open={showModal}
          onOk={() => setShowModal(false)}
          closable={true}
          onCancel={() => setShowModal(false)}
          okText="Voltar"
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <DescriberPayload exibeMensagemErro={false} {...modalData} />
        </ModalCentralizada>
        <Table
          tableLayout="auto"
          rowSelection={rowSelection}
          columns={colunas}
          dataSource={webhooks}
          scroll={{ x: 1000 }}
          loading={loadingApiData}
          pagination={{
            ...pager,
            showTotal: total =>
              `Total de ${total} ${total > 1 ? 'itens' : 'item'}`,
            showQuickJumper: true,
            showSizeChanger: true,
          }}
          onChange={buscaFiltrada}
          size="big"
        />
        <Modal
          styles={{ body: { overflowY: 'scroll', maxHeight: '50vh' } }}
          title="Confirmação de reprocessamento carga avulsa"
          open={abrirModalDeReprocessamento}
          onOk={reprocessarWebhooks}
          onCancel={() => setAbrirModalDeReprocessamento(false)}
          okText="Reprocessar"
          okButtonProps={{ disabled: loadingReprocessamento }}
        >
          <Spin
            spinning={loadingReprocessamento}
            size="large"
            style={{
              position: 'fixed',
              top: '25%',
            }}
            tip="Aguarde sem fechar a janela!"
            delay={200}
          >
            <List
              bordered
              split={true}
              dataSource={reprocessarData}
              renderItem={(data, key) => (
                <List.Item>
                  <Row gutter={[24, 24]} key={key}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      Id:
                      <Typography.Text strong>
                        &nbsp;
                        {data.id}
                      </Typography.Text>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      Identificador:
                      <Typography.Text strong>
                        &nbsp;
                        {data.identificador}
                      </Typography.Text>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      Tipo:
                      <Typography.Text strong>
                        &nbsp;
                        {data.tipo}
                      </Typography.Text>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      Mensagem:
                      <Typography.Text strong>
                        &nbsp;
                        {data.mensagemDeErro}
                      </Typography.Text>
                    </Col>
                  </Row>
                </List.Item>
              )}
            />
          </Spin>
        </Modal>
        <Row>
          <Col span={24}>
            <Button
              disabled={!bloquearBotaoReprocessar}
              type="primary"
              size="large"
              onClick={exibirModalReprocessamento}
              style={{ marginTop: 20, float: 'right' }}
            >
              Reprocessar
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
}
